import { CartItem } from '../../app/types/api-types';
import { DialogList, DialogListButton, DialogListItem } from '../../controls/dialog-list/dialog-list';
import styles from './carts-panel.module.css';

export function CartsPanel({ cartList, deleting, disabled, messages, onEditCart, onRemoveCart } : {
    cartList: CartItem[]
    deleting?: number[]
    disabled?: boolean
    onEditCart: (id:number) => void
    onRemoveCart: (id:number) => void
    messages: Record<string,string>
}) {

    if(cartList.length === 0) {
        return <p>{ messages.no_baskets }</p>
    } else {
        return <DialogList>
        {
            cartList.map(cart => {
                const date = `${cart.date.substring(8,10)}/${cart.date.substring(5,7)}/${cart.date.substring(0,4)}`;
                const isDeleting = deleting ? deleting.includes(cart.shoppingcartID) : false;
                return <DialogListItem key={cart.shoppingcartID} className={styles.cartsListItem} deleting={isDeleting}>
                    <span className={styles.code}>{cart.shoppingcartcode}</span>
                    <span className={styles.reference}>{cart.name}</span>
                    <span className={styles.date}>{date}</span>
                    <span className={styles.actions}>
                        <DialogListButton type="button" disabled={disabled} onClick={() => onEditCart(cart.shoppingcartID)}>{messages.basket_edit}</DialogListButton>
                        <DialogListButton type="button" disabled={disabled} onClick={() => onRemoveCart(cart.shoppingcartID)}>{messages.basket_remove}</DialogListButton>
                    </span>
                </DialogListItem>
            })
        }
        </DialogList>    
    }

}